<template>
	<section>
		<!-- Header -->
		<section class="d-block" name="DokumenAmandemen" v-can="'kontrak/amandemen_pusat/read'">
			<div class="row align-items-center justify-content-between">
				<div class="col-12 col-sm-8 col-lg-6 mb-1">
					<h4 class="card-title mb-0">
						Dokumen Amandemen
						<button type="button" v-can="'kontrak/amandemen_pusat/create'"
							class="btn btn-primary btn-block-mobile" @click="openFormAddAmandemen('option')">
							Tambah Amandemen
						</button>
					</h4>
				</div>
			</div>
		</section>

		<!-- Amandement Proses Section -->
		<section v-if="amendmentProcess.length" class="d-block" name="DokumenAmandemen"
			v-can="'kontrak/amandemen_pusat/read'">
			<div class="row align-items-center justify-content-between mb-2">
				<div class="col-12 col-sm-8 col-lg-6">
					<h4 class="card-title mb-0">
						Amandemen Proses
					</h4>
				</div>

				<div v-if="amendmentProcess.length" class="col-12 col-sm-4">
					<div class="input-group form-search-rounded">
						<input class="form-control py-2 border-right-0 border" type="search" placeholder="Cari" />
						<span class="input-group-append">
							<div class="input-group-text bg-transparent">
								<a href="#" class="text-blue"><i class="fa fa-search"></i></a>
							</div>
						</span>
					</div>
				</div>
			</div>

			<div v-for="(amendment, amendmentProcessIdx) in amendmentProcess" :key="amendment.id">
				<div class="text-center"
					style="background: #03566B; color: white; position: relative; padding: 1rem 0;">{{
						amendment.name }} |
					Perihal: {{ getPerihalText(amendment.perihal) }}
					<button v-can="'kontrak/amandemen_pusat/delete'" type="button" class="btn btn-icon-small text-white"
						style="position: absolute; right: 10px; top: 5px;" @click="deleteAmendment(amendment.id)">
						<i class="fa fa-trash"></i>
					</button>
				</div>
				<div class="table-responsive no-sort w-100 mb-2">
					<table class="table tabel-status-document w-100" style="white-space: nowrap;">
						<thead>
							<tr>
								<th></th>
								<th>Tanggal</th>
								<th>Uraian Proses</th>
								<th>Nomor</th>
								<th v-can="'kontrak/amandemen_pusat/read_file'">
									<i class="feather icon-download-cloud fa-l"></i> File
								</th>
								<th>Durasi Berjalan</th>
								<th>Status</th>
								<th>Keterangan</th>
								<th class="w10">Aksi</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(doc, docProcessIdx) in amendment.documents" :key="doc.id">
								<td>
									<input type="checkbox" :checked="doc.status == '5'" onclick="return false;" />
								</td>
								<td>{{ doc.tanggal }}</td>
								<td>{{ doc.name }}</td>
								<td>{{ doc.nomor }}</td>
								<td class="file-detail" v-can="'kontrak/amandemen_pusat/read_file'">
									<a v-if="doc.document" @click="pdfViewer(doc.document)" href="javascript:;">[Lihat
										Detail]</a>
									<span v-else>-</span>
								</td>
								<td>{{ doc.duration ? `${Math.abs(doc.duration)} Hari` : '-' }}</td>
								<td>
									<div v-if="doc.status" class="alert mb-0 text-center"
										:class="getAmendmentStatusColor(doc.status)" role="alert">
										{{ getAmendmentStatusText(doc.status) }}
									</div>
									<span v-else>-</span>
								</td>
								<td>
									<div class="custom-notes-wrapper">
										<button @click="onOpenModalNotes('edit', doc)"
											style="font-size: 12px; border: none; background: transparent;"
											type="button" class="text-muted"><i class="fa fa-pencil"></i></button>
										<button @click="onOpenModalNotes('detail', doc)"
											style="font-size: 12px; border: none; background: transparent;"
											type="button" class="text-muted"><i class="fa fa-eye"></i></button>
										<div class="custom-notes" v-html="truncateHtml(doc.notes, 15)"></div>
									</div>
								</td>
								<td>
									<div v-if="eligibleModifyAmendment(amendment.documents[docProcessIdx - 1])" class="btn-action-block">
										<button type="button"
											class="btn btn-icon-small btn-warning-trans waves-effect waves-light"
											v-can="'kontrak/amandemen_pusat/update'" @click="openDetail({
												...doc,
												// for amandement parent index
												amendmentProcessIdx,
												// for spesific process index
												docProcessIdx,
												parent: amendment
											}, 'edit')">
											<i class="fa fa-pencil"></i>
										</button>
										&emsp;
										<button type="button" v-can="'kontrak/amandemen_pusat/detail'"
											@click="openDetail(doc, 'detail')"
											class="btn btn-icon-small btn-success-trans waves-effect waves-light">
											<i class="fa fa-eye"></i>
										</button>
									</div>
								</td>
							</tr>
							<tr>
								<td colspan="9" class="text-center">Total durasi: {{
									getTotalDuration(amendment.documents) }}</td>
							</tr>
							<tr v-if="!amendment.documents.length">
								<th colspan="9" class="text-center">Tidak ada data.</th>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<hr class="my-2" />
		</section>

		<!-- Form Pilih Jenis Amandemen (pusat / unit) -->
		<div class="modal fade text-left show" id="Modal_AmandemenOption" tabindex="-1" role="dialog"
			aria-labelledby="myModalLabel160" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<!-- Header -->
					<div class="modal-header modal-primary white">
						<h5 class="modal-title">
							Pilih Jenis Amandemen
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>


					<!-- Body -->
					<div class="modal-body">
						<button @click="openFormAddAmandemen('Kontrak Unit')" class="amandemen-option-btn">Tambah
							Amandemen
							Kontrak
							Unit</button>
						<hr>
						<button @click="openFormAddAmandemen('Kontrak Pusat')" class="amandemen-option-btn">Tambah
							Amandemen
							Kontrak
							Pusat</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Form Update Amandemen -->
		<div class="modal fade text-left show" id="Modal_AmandemenUpdate" tabindex="-1" role="dialog"
			aria-labelledby="myModalLabel160" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div v-if="amendmentDoc" class="modal-content">
					<ValidationObserver ref="amandemenUpdateForm">
						<!-- Header -->
						<div class="modal-header modal-primary white">
							<h5 class="modal-title">
								{{ isDetailModal ? 'Detail' : 'Upload file' }}
							</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>


						<!-- Body -->
						<div class="modal-body">
							<div v-show="!isDetailModal" class="form-group">
								<vue-dropzone ref="amandemenDropzone" id="wjw" :duplicateCheck="true"
									@vdropzone-files-added="amandemenFileHandler"
									:options="kontraktual_dropzoneOptions">
								</vue-dropzone>
								<button v-if="Boolean(amendmentDoc.document)" @click="amandemenDeleteFile"
									class="btn btn-danger" style="margin-top: 10px">
									Reset File
								</button>
								<ValidationProvider :rules="amendmentDoc.status == '5' ? 'required' : ''" name="Dokumen"
									v-slot="{ errors }">
									<input type="hidden" v-model="amendmentDoc.document" />
									<p style="color: #ea5455">{{ errors[0] }}</p>
								</ValidationProvider>
							</div>
							<div v-show="isDetailModal" class="form-group">
								<label>{{ amendmentDoc.name }}</label>
								<div v-if="amendmentDoc" class="input-group">
									<input disabled type="text" class="form-control" :value="amendmentDoc?.name">
									<span class="input-group-btn">
										<button @click="pdfViewer(amendmentDoc.document)" class="btn btn-default"
											type="button">Lihat Detail</button>
									</span>
								</div>
							</div>

							<div class="form-group">
								<ValidationProvider name="Nomor Amandemen" v-slot="{ errors }"
									:rules="amendmentDoc.status == '5' ? 'required' : ''">
									<label for="filter_by">Nomor</label>
									<input :disabled="isDetailModal" v-model="amendmentDoc.nomor" type="text"
										class="form-control" placeholder="Nomor Amandemen" :class="Boolean(errors[0])
											? 'form-control is-invalid'
											: 'form-control'
											" />
									<small>{{ errors[0] }} </small>
								</ValidationProvider>
							</div>

							<div class="form-group">
								<ValidationProvider name="Tanggal" v-slot="{ errors }" :rules="docDateRules">
									<label for="">Tanggal Dokumen</label>
									<div class="position-relative has-icon-right">
										<date-picker :disabled="isDetailModal" v-model="amendmentDoc.tanggal"
											:disabled-date="date => documentDateValidation(date, amendmentProcess[amendmentDoc.amendmentProcessIdx].documents[amendmentDoc.docProcessIdx - 1]?.tanggal)"
											format="DD/MM/YYYY" type="date" :input-class="Boolean(errors[0])
												? 'form-control is-invalid no-x'
												: 'form-control'
												" value-type="YYYY-MM-DD" placeholder="Masukan tanggal dokumen (dd/mm/yyyy)" style="width: 100%">
										</date-picker>
									</div>
									<small>{{ errors[0] }} </small>
								</ValidationProvider>
							</div>

							<div class="form-group">
								<ValidationProvider name="Status" v-slot="{ errors }">
									<label for="">Status</label>
									<select :disabled="isDetailModal || amendmentDoc._status == '5'" class="form-control"
										:class="Boolean(errors[0])
											? 'form-control is-invalid'
											: 'form-control'
											" v-model="amendmentDoc.status">
										<option :value="null">- Pilih Status -</option>
										<option v-for="status in amendmentStatus" :key="status.id"
											:value="status.level">{{
												status.name
											}}</option>
									</select>
									<small>{{ errors[0] }} </small>
								</ValidationProvider>
							</div>

							<div v-if="amendmentDoc.name === 'Amandemen Terbit' && (amendmentDoc.perihal && amendmentDoc.perihal.find(p => p.name == 'Perubahan Waktu Pelaksanaan'))" class="form-group">
								<ValidationProvider name="Tanggal Akhir Kontrak" v-slot="{ errors }">
									<label for="tanggal_akhir">Tanggal Akhir Kontak</label>
									<div class="position-relative has-icon-rig	ht">
										<date-picker v-model="amendmentDoc.parent.tgl_akhir" id="tanggal_akhir"
											format="DD/MM/YYYY" type="date" :input-class="Boolean(errors[0])
												? 'form-control is-invalid no-x'
												: 'form-control'
												" value-type="YYYY-MM-DD" placeholder="Masukan tanggal akhir kontrak" style="width: 100%">
										</date-picker>
									</div>
									<small>{{ errors[0] }} </small>
								</ValidationProvider>
							</div>

							<div v-if="amendmentDoc.name === 'Amandemen Terbit' && (amendmentDoc.perihal && amendmentDoc.perihal.find(p => p.name == 'Perubahan Biaya Pemborongan'))">
								<h5>Nilai Kontrak</h5>
								<div class="row mb-2">
									<div class="col-12 col-sm-4">
										<div class="form-group">
											<label for="">IDR</label>
											<div class="position-relative has-icon-left">
												<money v-model="amendmentDoc.parent.idr" class="form-control"
													v-bind="money" :disabled="amandemenTr === 'detail'"></money>
												<div class="form-control-position">Rp</div>
											</div>
										</div>
									</div>

									<div class="col-12 col-sm-4">
										<div class="form-group">
											<label for="">CNY</label>
											<div class="position-relative has-icon-left">
												<money v-model="amendmentDoc.parent.cny" class="form-control"
													v-bind="money" :disabled="amandemenTr === 'detail'"></money>
												<div class="form-control-position">&#x5143;</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-sm-4">
										<div class="form-group">
											<label for="">JPY</label>
											<div class="position-relative has-icon-left">
												<money v-model="amendmentDoc.parent.jpy" class="form-control"
													v-bind="money" :disabled="amandemenTr === 'detail'"></money>
												<div class="form-control-position">&#xa5;</div>
											</div>
										</div>
									</div>

									<div class="col-12 col-sm-4">
										<div class="form-group">
											<label for="">EUR</label>
											<div class="position-relative has-icon-left">
												<money v-model="amendmentDoc.parent.eur" class="form-control"
													v-bind="money" :disabled="amandemenTr === 'detail'"></money>
												<div class="form-control-position">&euro;</div>
											</div>
										</div>
									</div>

									<div class="col-12 col-sm-4">
										<div class="form-group">
											<label for="">USD</label>
											<div class="position-relative has-icon-left">
												<money v-model="amendmentDoc.parent.usd" class="form-control"
													v-bind="money" :disabled="amandemenTr === 'detail'"></money>
												<div class="form-control-position">$</div>
											</div>
										</div>
									</div>

									<div class="col-12 col-sm-12">
										<ValidationProvider name="Nilai Kontrak" v-slot="{ errors }">
											<input type="hidden" />
											<p style="color: #ea5455">
												{{
													Boolean(errors[0])
														? "*Nilai Kontrak tidak boleh Rp 0"
														: ""
												}}
											</p>
										</ValidationProvider>
									</div>
								</div>
								<p>Equivalent</p>
								<h3 class="font-bold">{{ equivalent | currency }}</h3>
							</div>
						</div>

						<div v-if="!isDetailModal" class="modal-footer">
							<button type="button" class="btn btn-outline-primary" data-dismiss="modal">
								Tutup
							</button>
							<AppButton :loading="isLoading" @click="updateDoc" type="button" class="btn btn-primary">
								<span>Simpan</span>
							</AppButton>
						</div>
					</ValidationObserver>
				</div>
			</div>
		</div>

		<!-- Form Update Keterangan -->
		<div class="modal fade text-left show" id="Modal_KeteranganAmandemen" tabindex="-1" role="dialog"
			aria-labelledby="myModalLabel160" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div v-if="notesDoc" class="modal-content">
					<!-- Header -->
					<div class="modal-header modal-primary white">
						<h5 class="modal-title">
							{{ notesAction === 'detail' ? 'Detail Keterangan' : 'Update Keterangan' }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<quill-editor v-if="notesAction === 'edit'" :options="editorOption" v-model="notesDoc.notes"/>
						<p v-else v-html="notesDoc.notes ?? 'Belum ada keterangan'">
						</p>
					</div>

					<div v-if="notesAction === 'edit'" class="modal-footer">
						<AppButton :loading="isLoading" @click="updateNotes" type="button" class="btn btn-primary">
							Simpan
						</AppButton>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import { safeJSONParse } from '@/utils/json.js'
import AppButton from '@/components/AppButton.vue'
import { uploadFile } from '@/utils/file.js'
import { Money } from "v-money";
import ld from "lodash";
import moment from 'moment'

export default {
	name: 'AmandemenProsesSection',
	components: {
		Money,
		AppButton
	},
	props: {
		amendmentProcess: {
			type: Array,
			default: () => []
		},
		cur: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			isLoading: false,
			actionType: null,
			amendmentType: null,
			amendmentAction: null,
			amendmentDoc: null,
			notesAction: null,
			notesDoc: null,
			amendmentStatus: [],
			kontraktual_dropzoneOptions: {
				url: this.$baseUrl + "/v3/misc/upload",
				thumbnailWidth: 150,
				acceptedFiles: ".doc,.docx,application/msword,.pdf",
				autoProcessQueue: false,
				addRemoveLinks: false,
				uploadMultiple: true,
				maxFiles: 1,
				headers: { Authorization: "Bearer " + this.$store.state.token },
				paramName: "file",
				maxFilesize: 10000,
			},
			editorOption: {
				modules: {
					toolbar: [
						['bold', 'italic', 'underline'],
						[{ 'list': 'ordered' }, { 'list': 'bullet' }],
						[{ 'indent': '-1' }, { 'indent': '+1' }],
					]
				}
			},
			money: {
				decimal: ",",
				thousands: ".",
				prefix: "",
				suffix: "",
				precision: 2,
				masked: false,
			},
		}
	},
	watch: {
		amendmentWatcher() {
			this.$nextTick(() => {
				this.$refs.amandemenDropzone?.removeAllFiles()
				if (this.amendmentDoc.document) {
					let file = { size: 10240, name: this.amendmentDoc.name, type: "application/word" };
					let url = this.amendmentDoc.document;
					this.$refs.amandemenDropzone?.manuallyAddFile(file, url);
				}
			})
		}
	},
	computed: {
		equivalent() {
			if (!this.amendmentDoc || !this.amendmentDoc.parent) {
				return '';
			}
			const { idr = 0, cny = 0, jpy = 0, eur = 0, usd = 0 } = this.amendmentDoc.parent;
			const { cny: cnyRate = 0, jpy: jpyRate = 0, eur: eurRate = 0, usd: usdRate = 0 } = this.cur;

			const equi =
				parseFloat(idr || 0) +
				parseFloat(cny || 0) * parseFloat(cnyRate) +
				parseFloat(jpy || 0) * parseFloat(jpyRate) +
				parseFloat(eur || 0) * parseFloat(eurRate) +
				parseFloat(usd || 0) * parseFloat(usdRate);

			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			this.amendmentDoc.parent.nilai_kontrak = equi;
			return equi;
		},
		isDetailModal() {
			return this.amendmentDoc && this.amendmentAction === 'detail'
		},
		amendmentWatcher() {
			return this.amendmentDoc || this.amendmentAction
		},
		docDateRules() {
			if (this.isDetailModal) return null;

			const previousDate = this.getPreviousDocumentDate();
			const dateOrderRule = previousDate ? `date_order:${previousDate}` : '';

			return this.amendmentDoc.status === '5'
				? `required|${dateOrderRule}`.trim()
				: dateOrderRule || null;
		},
	},
	methods: {
		truncateHtml(html, maxLength = 100) {
			// Create a temporary div to parse HTML
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = html;

			// Get text content length
			const textContent = tempDiv.textContent || tempDiv.innerText || '';

			// If content is shorter than maxLength, return original
			if (textContent.length <= maxLength) {
				return html;
			}

			// Truncate and add ellipsis
			let truncated = '';
			let currentLength = 0;

			const walkNodes = (node) => {
				if (currentLength >= maxLength) return;

				if (node.nodeType === Node.TEXT_NODE) {
					const remainingLength = maxLength - currentLength;
					const text = node.textContent;

					if (text.length <= remainingLength) {
						truncated += text;
						currentLength += text.length;
					} else {
						truncated += text.substring(0, remainingLength) + '...';
						currentLength = maxLength;
					}
				} else if (node.nodeType === Node.ELEMENT_NODE) {
					const tagName = node.tagName.toLowerCase();
					truncated += `<${tagName}`;

					// Add attributes if any
					for (let attr of node.attributes) {
						truncated += ` ${attr.name}="${attr.value}"`;
					}
					truncated += '>';

					// Process child nodes
					for (let child of node.childNodes) {
						walkNodes(child);
						if (currentLength >= maxLength) break;
					}

					truncated += `</${tagName}>`;
				}
			};

			for (let child of tempDiv.childNodes) {
				walkNodes(child);
				if (currentLength >= maxLength) break;
			}

			return truncated;
		},
		eligibleModifyAmendment(document) {
			return !document || document.status === '5';
		},
		getPreviousDocumentDate() {
			return this.amendmentProcess[this.amendmentDoc.amendmentProcessIdx]
				?.documents[this.amendmentDoc.docProcessIdx - 1]?.tanggal;
		},
		openDetail(doc, action) {
			this.amendmentDoc = ld.cloneDeep({...doc, _status: doc.status, perihal: safeJSONParse(doc.perihal)})
			this.amendmentAction = action
			this.$nextTick(() => {
				window.$("#Modal_AmandemenUpdate").modal("show");
			})
		},
		openFormAddAmandemen(action) {
			// Open form action options
			if (action === 'option') {
				window.$("#Modal_AmandemenOption").modal("show");
			} else {
				// Open form input
				this.amendmentType = action
				this.$emit('onOpenForm', {
					action: 'add',
					amendmentType: action
				})
			}
		},
		getAmendmentStatus() {
			let _ = this;
			return _.axios
				.get(`/v3/misc/amandemen-status`)
				.then((resp) => {
					_.amendmentStatus = resp.data.data;
				})
				.catch((err) => {
					console.log(err.response);
				});
		},
		getTotalDuration(documents) {
			let total = 0
			documents.forEach(doc => {
				total += Math.abs(doc.duration)
			})
			return `${total} Hari`
		},
		getAmendmentStatusColor(status) {
			const statusColors = {
				0: 'alert-warning', // under review
				3: 'alert-danger', // dokumen tidak lengkap
				5: 'alert-success', // success
			};

			return statusColors[status] || 'alert-info';
		},
		getAmendmentStatusText(status) {
			return this.amendmentStatus.find(s => s.level == status)?.name ?? null;
		},
		getPerihalText(perihal) {
			const _perihal = safeJSONParse(perihal);
			if (!Array.isArray(_perihal)) return '';
			return _perihal.map(p => p.name).join(', ');
		},
		amandemenFileHandler(file) {
			let _ = this;

			if (file[0].size / 1000000 < _.kontraktual_dropzoneOptions.maxFilesize) {
				window.$.each(file, function (index, file) {
					_.amendmentDoc.document = file
				});
			} else {
				_.$refs.amandemenDropzone.removeAllFiles()
			}
		},
		amandemenDeleteFile() {
			let _ = this;
			_.$refs.amandemenDropzone.removeAllFiles()
			_.amendmentDoc.document = null
		},
		onOpenModalNotes(action, doc) {
			this.notesAction = action
			this.notesDoc = JSON.parse(JSON.stringify(doc))
			window.$("#Modal_KeteranganAmandemen").modal("show");
		},
		async updateNotes() {
			let _ = this;
			_.isLoading = true
			return _.axios
				.put(`/v3/kontrak/${this.notesDoc?.id}/amandemen-proses/notes`, { notes: this.notesDoc?.notes })
				.then(() => {
					_.$toast.success(`Catatan ${this.notesDoc?.name} berhasil disimpan`);
					this.$emit('onRefreshList');
					window.$("#Modal_KeteranganAmandemen").modal("hide");
				})
				.catch((err) => {
					console.log(err.response);
				})
				.finally(() => _.isLoading = false)
		},
		async updateDoc() {
			let _ = this;
			var validation = _.$refs.amandemenUpdateForm;
			validation.validate().then(async (success) => {
				if (!success) {
					return;
				}
				_.isLoading = true
				// Extract document from amendmentDoc
				const documentSource = _.amendmentDoc.document;

				// If documentSource is null or undefined, set document to null
				// Otherwise process based on type
				const document = !documentSource
					? null
					: typeof documentSource === 'string'
						? documentSource
						: await uploadFile(documentSource, 'amandemen_proses');

				let body = {
					nomor: _.amendmentDoc.nomor,
					document,
					tanggal: _.amendmentDoc.tanggal,
					status: _.amendmentDoc.status,
					idr: _.amendmentDoc.parent.idr,
					cny: _.amendmentDoc.parent.cny,
					jpy: _.amendmentDoc.parent.jpy,
					eur: _.amendmentDoc.parent.eur,
					usd: _.amendmentDoc.parent.usd,
					tgl_akhir: _.amendmentDoc.parent.tgl_akhir,
					nilai_kontrak: _.amendmentDoc.parent.nilai_kontrak,
					perihal: safeJSONParse(_.amendmentDoc.perihal)
				}
				_.axios
					.put(`/v3/kontrak/${_.amendmentDoc.id}/amandemen-proses`, body)
					.then(() => {
						_.$toast.success(`Dokumen berhasil diupdate`);
						window.$("#Modal_AmandemenUpdate").modal("hide");
						this.$emit('onRefreshList');
					})
					.catch((err) => {
						console.log(err.response);
					})
					.finally(() => _.isLoading = false)
			})
			.finally(() => _.isLoading = false)
		},
		documentDateValidation(date, prevDate) {
			const today = moment().startOf('day'); // Ensure today is compared without time
			const selectedDate = moment(date).startOf('day'); // Remove time from the selected date

			// If no previous date exists, date should not be in the future
			if (!prevDate) {
				return selectedDate.isAfter(today); // Invalid if after today
			}

			const previousDate = moment(prevDate).startOf('day'); // Remove time from prevDate

			// If previous date exists, date should be between prevDate and today (inclusive)
			return selectedDate.isBefore(previousDate) || selectedDate.isAfter(today);
		},
		pdfViewer(file) {
			this.$emit('showPdf', file);
		},
		deleteAmendment(amendmentId) {
			let _ = this;
			_.$swal
				.fire({
					title: "Hapus Data Ini?",
					text: "Anda mungkin tidak akan mengembalikannya lagi!",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#44A8BD",
					cancelButtonColor: "#D95E6A",
					confirmButtonText: "Ya, Hapus!",
					cancelButtonText: "Batal",
				})
				.then((result) => {
					if (result.value) {
						_.isLoading = true
						_.axios
							.delete(`/v3/kontrak/${amendmentId}/amandemen-proses`)
							.then((resp) => {
								if (resp.status) {
									this.$swal.fire({
										title: "Terhapus!",
										text: "Data berhasil dihapus",
										icon: "success",
										confirmButtonColor: "#37BA71",
										confirmButtonText: "OK",
									});
									this.$emit('onRefreshList');
								} else {
									console.log("Failed");
								}
							})
							.catch((err) => {
								_.$toast.warning('Gagal menghapus data!')
								console.log(err.response);
							})
							.finally(() => _.isLoading = false)
					}
				})
		}
	},
	mounted() {
		this.getAmendmentStatus()
	}
}
</script>
<style>
td.file-detail {
	display: table-cell !important;
}

button.amandemen-option-btn {
	border: none;
	outline: none;
	background: transparent;
}

.custom-notes-wrapper {
	display: flex;
	align-items: center;
	gap: 4px;
}

.custom-notes-wrapper button {
	margin-top: -10px !important;
}

.custom-notes {
	max-width: 140px !important;
	overflow: hidden;
}

.custom-notes,
.custom-notes * {
	display: inline-flex !important;
	align-items: center;
	margin: 0 !important;
	padding: 0 !important;
	list-style: unset !important;

	font-weight: 400 !important;
	font-style: normal !important;
	text-decoration: none;
	gap: 4px;
}
</style>